import { withStaticProperties } from "@tamagui/core";
import { AcknowledgementActions, DestructiveActions, TransactionalActions } from "./Actions.mjs";
import { Content } from "./Content.mjs";
import { Dialog as DialogFrame } from "./Dialog.mjs";
const Dialog = withStaticProperties(DialogFrame, {
  Content,
  DestructiveActions,
  AcknowledgementActions,
  TransactionalActions
});
export { Dialog };